import React from "react";

export default function TemporaryDrawer() {
  return <div style={{ display: "flex" }}></div>;
}
